import { PrivateInterceptorsPR } from "../../../Base/interceptors/PrivateinterceptorsPR";
import { PublicInterceptorPR } from "../../../Base/interceptors/PublicInterceptorsPR";

// OBTENER POSICIONES

export const getPosiciones = async () => {
    const result = await PrivateInterceptorsPR(`Posiciones`, 'GET');
    return result;
}

export const posicionesDistinc = async () => {
    const result = await PublicInterceptorPR(`Posiciones/PosicionesDistinc`, 'GET');
    return result;
}

export const getPosicionesToken = async (token) => {
    const result = await PublicInterceptorPR(`Posiciones`, 'GET', {}, token);
    return result;
}
